var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dealerdetails__reviews_avatar"},[_c('div',{staticClass:"avatar avatar",style:({ 'background-color': _vm.getBgColour })},[_vm._v(" "+_vm._s(_vm.item.charAt(0))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }